<template>
<div>
    <b-tabs v-model="activeTab" class="notification-tab">
            <b-tab-item v-for="(notifLabel, index) in possibleLabels" :key="index" :label="notifLabel.name">
                <div class="mt-4 px-2" v-for="(notification, notifIndex) in filteredNotification(notifLabel.type)" :key="notifIndex">
                    <b-message v-if="getType(notification.notificationStatus)" :closable="false" :title="getType(notification.notificationStatus).name" :type="getType(notification.notificationStatus).warning">
                        {{ notification.studentName }}
                        <b-button v-if="notification.notificationStatus !== 'noPrintScreen'" tag="router-link" :to="{ name: 'sfe-form' , params: filterByStudentId(notification.studentId)}" type="is-info" style="margin-top:4px">View SFE</b-button>
                    </b-message>
                </div>
            </b-tab-item>
        </b-tabs>
</div>
</template>

<script>
export default {
    name: "notifications-tab",
    data() {
        return {
            activeNotifications: [],
            activeTab: 0,
            possibleLabels: [{
                    name: 'All',
                    type: null
                },
                {
                    name: 'SFE not started',
                    type: 'notStartedSfe',
                    warning: 'is-warning'
                },
                {
                    name: 'SFE in Draft',
                    type: 'inDraft',
                    warning: 'is-warning'
                },
                {
                    name: 'SFE Info Required',
                    type: 'infoRequired',
                    warning: 'is-danger'
                },
                {
                    name: 'Missing printscreen',
                    type: 'noPrintScreen',
                    warning: 'is-danger'
                },
            ]
        }
    },
    computed: {
        getNotifications() {
            return this.filteredNotification(null)
        }
    },
    mounted() {

    },
    methods: {
        filterByStudentId(studentId) {
            const application = this.$store.state.application.applications.filter(app => app.studentId === studentId)[0]
            return {
                id: studentId,
                studentFormProp: application.studentForm,
                templateOptions: application.studentData,
                fullCourse: application.fullCourse,
                appRow: application
            }
        },

        getType(notificationStatus) {
            const foundFilter = this.possibleLabels.filter(label => label.type === notificationStatus)[0]
            return foundFilter ? foundFilter : {

            }
        },

        filteredNotification(notificationStatus) {
            return notificationStatus ? this.$store.state.application.notifications.filter(notif => notif.notificationStatus === notificationStatus) : this.$store.state.application.notifications
        }
    }
}
</script>

<style>


.b-tabs.notification-tab .tab-content .tab-item {
    overflow-y: scroll;
    max-height: 90vh;
}

.b-tabs.notification-tab .tab-content .tab-item .media-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>